import React from 'react';
import { Popover } from '@barges/react';
import classes from './classes.module.scss';

const errorX = require('./img/error_x.svg');
const closeIcon = require('./img/close_icon.svg');

function Alert({
  errorString,
  message = 'Error',
  onClose,
  banner = false
}) {
  const renderCloseBtn = () => {
    if (onClose) {
      return (
        <div className={ classes.closeBtnContainer } onClick={ onClose } onKeyDown={ onClose }>
          <img src={ closeIcon } alt="" className={ classes.closeBtnImg } />
        </div>
      );
    }
    return null;
  };

  const renderAlertContent = () => (
    <div className={ classes.alertContentContainer }>
      { renderCloseBtn() }
      <div className={ classes.errorXImgContainer }>
        <img src={ errorX } alt="" className={ classes.errorXImg } />
      </div>
      <div className={ classes.textContainer }>
        <div className={ classes.messageContainer }>
          { message }
        </div>
        <div className={ classes.errorStringContainer }>
          { errorString }
        </div>
      </div>
    </div>
  );

  const renderAlert = () => {
    if (banner) return renderAlertContent();
    return (
      <Popover
        isOpen={ !!errorString && errorString !== '' }
        centered
        contentClassName={ classes.alertPopoverContentContainer }
        closeOnBackdropClick
      >
        { renderAlertContent() }
      </Popover>
    );
  };

  return renderAlert();
}

export default Alert;
